import React from 'react';
import { Navigate } from 'react-router-dom';

const PrinterRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));

  if (!user || user.role !== 'PRINTER') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrinterRoute;
